import styled from "styled-components";
import { Tag as BlueprintTag } from "@blueprintjs/core";

export const Tag = styled(BlueprintTag)`
  font-size: var(--global-font-size-xs);
  line-height: 16px;
  color: #0974d7;
  background: #f2f8ff;
  border-radius: 3px;
  & span {
    white-space: unset;
  }
`;
